import { createContext, FC, PropsWithChildren, useMemo } from 'react'
import { createContextualCan, useAbility } from '@casl/react'
import { useSelector } from 'react-redux'

import { getUser } from 'redux/store/user/getters'
import { Abilities } from '../../VendorInfo'
import { AnyAbility } from '@casl/ability'

export const VendorDetailsDetailsAbilityContext =
  createContext<Abilities.VendorDetailsAbility>(Abilities.ability)

const VendorDetailsAbilityProvider: FC<PropsWithChildren> = ({ children }) => {
  const user = useSelector(getUser)

  const ability = useMemo(() => Abilities.defineAbility(user), [user])

  return (
    <VendorDetailsDetailsAbilityContext.Provider value={ability}>
      {children}
    </VendorDetailsDetailsAbilityContext.Provider>
  )
}

export const useVendorDetailsAbility = () =>
  useAbility<Abilities.VendorDetailsAbility>(VendorDetailsDetailsAbilityContext)

export const Can = createContextualCan<AnyAbility>(
  VendorDetailsDetailsAbilityContext.Consumer
)

export default VendorDetailsAbilityProvider
